jQuery(function($){
	var canBeLoaded = true, // this param allows to initiate the AJAX call only if necessary
	    bottomOffset = 2000; // the distance (in px) from the page bottom when you want to load more posts

	if ( loadmore_params.disable != '1' ) {
		$(window).scroll(function(){
			var data = {
				'action' : 'loadmore',
				'query'  : loadmore_params.posts,
				'page'   : loadmore_params.current_page
			};
			if( $(document).scrollTop() > ( $(document).height() - bottomOffset ) && canBeLoaded == true ){
				$.ajax({
					url        : loadmore_params.ajaxurl,
					data       :data,
					type       :'POST',
					beforeSend : function( xhr ){
						canBeLoaded = false;
					},
					success:function(data){
						if( data ) {
							$('.site-main > .wrapper').find('article:last-of-type').after( data ); // where to insert posts
							canBeLoaded = true; // the ajax is completed, now we can run it again
							loadmore_params.current_page++;
						}
					}
				});
			}
		});
	}
});
